/**
 * transforma el json iece en un objeto mas simple `Schema` conservando la misma estructura jerarquica
 * @param {Object} iece la in4
 * @returns {Schema}
 */

export function createSchemaFromIece(iece) {
  const schema = {};
  flatmap(iece, schema);
  return schema;

  function flatmap(json, res, model = '') {
    const name = json.name || json.items.name;
    const title = json.title || '';
    const required = json.use === 'required' || json.minItems > 0;
    const type = getType(json.maxItems);
    const properties = json.properties || (json.items && json.items.properties);
    //
    model += (model ? '.' : '') + name;
    res[name] = { /*name,*/ title, model, required, type };
    if (properties) {
      res[name].properties = {};
      Object.keys(properties).forEach(childName => flatmap(properties[childName], res[name].properties, model));
    }
  }
}

function getType(maxItems) {
  if (maxItems === 1) {
    return 'object';
  }
  if (maxItems > 1) {
    return 'array';
  }
  return 'data';
}
